<template>
	<div class="my-3 my-md-5">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header justify-content-between">
							<h3 class="card-title">Projects</h3>
							<button type="button" class="btn btn-sm btn-outline-primary text-uppercase" data-toggle="modal" data-target="#detailsModal" @click="openAddModal"><i class="fe fe-plus d-block" title="Add New"></i></button>
						</div>
						<div class="table-responsive">
							<table class="table table-hover table-outline table-vcenter text-nowrap card-table">
								<thead>
									<tr>
										<th class="text-center">Sr. No.</th>
										<th>Name</th>
										<th>Color</th>
										<th>Status</th>
										<th class="text-center">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="dataArray.length == 0">
										<td colspan="8" class="text-center">No data available</td>
									</tr>
									<tr v-else v-for="(data, index) in dataArray" :key="data._id">
										<td>
											<div class="text-center">
												{{ index+1 }}
											</div>
										</td>
										<td>
											<div>
												{{ data.name }}
											</div>
										</td>
										<td>
											<div>
												<span class="badge" :style="'background-color:'+data.color+';'">{{ data.color }}</span>
											</div>
										</td>
										<td>
											<div>
												{{ toTitleCase(data.status) }}
											</div>
										</td>
										<td class="text-center">
											<button type="button" class="btn btn-sm btn-default" title="Edit" @click="openEditModal(data)"><i class="fe fe-edit"></i></button>
											<button type="button" class="btn btn-sm btn-default ml-1" title="Delete" @click="openDeleteModal(data._id)"><i class="fe fe-trash"></i></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Add / Edit Modal -->
		<div class="modal fade" id="detailsModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<form id="dash-form" class="modal-content" @submit.prevent="submitDetailsForm">
					<div class="modal-header">
						<template v-if="modalTypeEdit">
							<h5 class="modal-title" id="exampleModalLabel">Edit Details</h5>
						</template>
						<template v-else>
							<h5 class="modal-title" id="exampleModalLabel">Add Details</h5>
						</template>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<div class="col-md-12">
								<div class="form-group alert alert-danger" role="alert">
									Woops! Something Went Wrong, Please Try Again.
								</div>  
							</div>
							<div class="col-md-6">
								<TextField :data="formData.name" name="name" label="Name" :required="true" v-bind:value.sync="formData.name"/>
								<ColorField :data="formData.color" name="color" label="Color" :required="true" v-bind:value.sync="formData.color"/>
							</div>
							<div class="col-md-6">
								<SelectOption :data="formData.status" name="status" label="Status" :required="true" v-bind:value.sync="formData.status" :optionList="['New','In Progress','Completed']"/>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="reset" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="submit" id="submit" class="btn btn-primary ml-2 text-uppercase">Sumbit</button>
					</div>
				</form>
			</div>
		</div>
		<!-- Delete Modal -->
		<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Confirm Delete</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						Delete this Data?
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary" @click="confirmDelete">Confirm</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import TextField from '@/components/form/TextField.vue'
import SelectOption from '@/components/form/SelectOption.vue'
import ColorField from '@/components/form/ColorField.vue'

export default {
	name: 'Projects',
	components: {
		TextField,
		SelectOption,
		ColorField
	},
	data() {
		return {
			modalTypeEdit: false,
			formData: {
				name: '',
				color: '',
				status: ''
			},
			dataId: ''
		}
	},
	mounted() {
		// Hide loader
		this.$store.dispatch('setLoading', false);
		/* global $ */
		let self = this;
		// Reset Form On Modal Hide
		$('#detailsModal').on('hidden.bs.modal', function () {
			self.resetFormData();
		});
		// Reset Delete Id On Modal Hide
		$('#deleteModal').on('hidden.bs.modal', function () {
			self.deleteId = '';
		});
		// Dummy Data
		/*this.dataArray = [
		{
			name: 'Basecamp Dashboard',
			color: '#1b4071',
			status: 'In Progress'
		},
		{
			name: '.Tech Website',
			color: '#1caf4b',
			status: 'Completed'
		},
		{
			name: '.Online Website',
			color: '#2bac50',
			status: 'Completed'
		},
		{
			name: '.Store Website',
			color: '#14aeb3',
			status: 'Completed'
		},
		]*/
	},
	computed: {
		dataArray: function() {
			return this.$store.getters.getProjects;
		}
	},
	methods: {
		submitDetailsForm: function() {
			let self = this;
			// Check Vee Validate
			self.$validator.validateAll().then((result) => {
				if (result) {
					// Add / Edit Projects Data
					if(self.modalTypeEdit == true) {
						self.sendData('projects-details', self.formData, self.dataId);
					}
					else {
						self.sendData('projects-details', self.formData);
					}
					return;
				}
			});
		},
		confirmDelete: function() {
			// Delete Projects Data
			this.deleteData('projects-details', this.dataId);
		},
		resetFormData: function() {
			this.modalTypeEdit = false;
			this.dataId = '';
			// Prefill Edit Values
			this.formData.name = '';
			this.formData.color = '';
			this.formData.status = '';
			// Emit Reset Event
			this.$root.$emit('reset-validation');
		},
		openAddModal: function() {
			this.modalTypeEdit = false;
			// Show Modals
			$('#detailsModal').modal('show');
		},
		openEditModal: function(obj) {
			this.modalTypeEdit = true;
			// Prefill Edit Values
			this.dataId = obj._id;
			this.formData.name = obj.name;
			this.formData.color = obj.color;
			this.formData.status = obj.status;
			// Show Modal
			$('#detailsModal').modal('show');
		},
		openDeleteModal: function(id) {
			this.dataId = id;
			// Show Modal
			$('#deleteModal').modal('show');
		}
	}
}
</script>
